import {BottomSheetDialog, Button, Div, ImageView, Input} from 'components';
import {Ecolors, Icons} from 'constant';
import React, {useCallback, useEffect, useRef, useState} from 'react';
import {debounce} from 'lodash';
import {
  getPaginationHistory,
  getQueriesHistory,
  loadHistory,
} from 'reducer/transaction';
import {useAppDispatch, useAppSelector} from 'store/hooks';
import {parseMultilanguage} from 'utils';
import FilterHistoryModal from './FilterHistoryModal';
import ListHistoryOrder from './ListHistoryOrder';

function HistoryTransaction(p: {activeTab: any}) {
  const dispatch = useAppDispatch();
  const [orderCode, setOrderCode] = useState<string>('');
  const queries = useAppSelector(state => getQueriesHistory(state));
  const pagination = useAppSelector(state => getPaginationHistory(state));
  const bottomSheetRef = useRef<{
    show: () => void;
    hide: () => void;
  }>(null);
  // handle search on type
  const orderCodeRef = useRef<any>();

  const handlerDebounce = useCallback(
    debounce(async nextValue => {
      await getData({
        orderCode: nextValue,
        pagination: {
          currentPage: 1,
        },
      });
    }, 500),
    [],
  );

  useEffect(() => {
    const getHistoryData = async () => {
      try {
        await dispatch(
          loadHistory({
            pagination: {currentPage: 1, itemsPerPage: 10},
            queries: {},
          }),
        );
      } catch (error) {
        console.log('error>', error);
      }
    };
    if (p.activeTab == 1) {
      setOrderCode('');
      getHistoryData();
    }
    return () => {};
  }, [p.activeTab]);

  const getData = async (p: {orderCode?: string; pagination?: any}) => {
    await dispatch(
      loadHistory({
        queries: {
          ...(queries || {}),
          orderCode: p.orderCode || '',
        },
        pagination: {...(pagination || {}), ...p.pagination},
      }),
    );
  };

  return (
    <>
      <BottomSheetDialog
        style={{
          flexDirection: 'column',
          flex: 1,
          alignItems: 'center',
          justifyContent: 'flex-end',
        }}
        ref={bottomSheetRef}>
        <FilterHistoryModal
          onBack={() => {
            if (bottomSheetRef.current) {
              bottomSheetRef.current.hide();
            }
          }}
        />
      </BottomSheetDialog>
      <Div flex={1}>
        <Div
          flexDirection={'row'}
          paddingHorizontal={16}
          alignItems={'center'}
          justifyContent={'space-between'}>
          <Div
            width={300}
            borderRadius={5}
            borderColor={Ecolors.bordercolor}
            borderWidth={0.8}
            flexDirection={'row'}
            alignItems={'center'}
            justifyContent={'space-between'}
            paddingLeft={15}
            paddingRight={14}
            height={36}>
            <Input
              inputRef={orderCodeRef}
              margin={0}
              value={orderCode}
              onChangeText={(e: string) => {
                setOrderCode(e);
                handlerDebounce(e);
              }}
              padding={0}
              color={Ecolors.textColor}
              placeholder={parseMultilanguage(`transactionscreen.nhapmalenh`)}
              placeholderTextColor={Ecolors.grayColor}
              keyboardType={'name-phone-pad'}
              flex={1}
            />
            <ImageView
              heightWidth={19}
              source={Icons.search}
              resizeMode={'contain'}
            />
          </Div>
          <Button
            onPress={() => {
              // navigate('FilterHistoryModal');
              if (bottomSheetRef.current) {
                bottomSheetRef.current.show();
              }
            }}
            heightWidth={36}
            alignItems={'center'}
            justifyContent={'center'}
            borderWidth={0.8}
            borderColor={Ecolors.bordercolor}
            borderRadius={5}>
            <ImageView
              source={Icons.filter}
              heightWidth={19}
              resizeMode={'contain'}
            />
          </Button>
        </Div>
        <ListHistoryOrder
          onRefresh={() => {
            setOrderCode('');
          }}
        />
      </Div>
    </>
  );
}

export default React.memo(HistoryTransaction);
